import { setVideoPlayerVisible } from 'src/store/slices/sentinel';
import { parseVideoUrl } from 'src/utils/videoParser';
import { useAppDispatch, useAppSelector } from 'universal-scripts';

import './VideoPlayer.css';

interface VideoPlayerProps {
	url: string;
}

export default function VideoPlayer({ url }: VideoPlayerProps) {
	const dispatch = useAppDispatch();
	const isVisible = useAppSelector((state) => state.sentinel.isVideoPlayerVisible);
	if (!isVisible) return null;

	const parsedVideo = parseVideoUrl(url);

	if (!parsedVideo.isValid || !parsedVideo.embedUrl) {
		return <span className="video-player__error">Error</span>;
	}

	const handleTogglePlayer = () => {
		dispatch(setVideoPlayerVisible(false));
	};

	return (
		<div className={`video-player video-player--${parsedVideo.orientation}`}>
			<button className="icon icon-cross" onClick={handleTogglePlayer} />
			<iframe src={parsedVideo.embedUrl} title="Video player" allow="fullscreen" allowFullScreen />
		</div>
	);
}
